exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.textbox__input {\r\n  border-bottom: 1px #0000008c solid;\n}\n#app .message--error {\r\n  z-index: 9999!important;\n}\r\n", ""]);

// exports
